export default function(ngModule) {
    ngModule.factory('Payout', function(BaseClass,$q, $http) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function Payout(attributes) {
            _.assign(this,attributes);
        }
        Payout.modelName = 'Payout';


        BaseClass.apply(Payout);

        // Invoice.validates();

        Payout.configureApi('/payout/:guid', {
            queryAdmin: '/payout/:status/:company'
        });
        Payout.prototype.toString = ()=> this.payout_number;

        return Payout;
    });
}
